var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-row",
    [
      _c(
        "w-col",
        { attrs: { xs: "12" } },
        [
          _c(
            "w-card",
            [
              _c("w-card-title", [_vm._v(_vm._s(_vm.$ct("qrcodes")))]),
              _c(
                "w-list",
                [
                  _vm._l(_vm.layout.QrCodes, function (code, i) {
                    return _c(
                      "w-list-item",
                      { key: code.key },
                      [
                        _c("w-list-item-text", [
                          _vm._v(" " + _vm._s(code.getName(_vm.model)) + " "),
                        ]),
                        _c(
                          "w-list-item-action",
                          [
                            _c(
                              "w-button",
                              {
                                directives: [
                                  {
                                    name: "tooltip",
                                    rawName: "v-tooltip",
                                    value: _vm.$ct("edit-qrcode"),
                                    expression: "$ct('edit-qrcode')",
                                  },
                                ],
                                on: {
                                  click: function ($event) {
                                    return _vm.editQrCode(code)
                                  },
                                },
                              },
                              [_c("w-fa", { attrs: { icon: "pen" } })],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "w-list-item-action",
                          [
                            _c(
                              "w-button",
                              {
                                directives: [
                                  {
                                    name: "tooltip",
                                    rawName: "v-tooltip",
                                    value: _vm.$ct("delete-qrcode"),
                                    expression: "$ct('delete-qrcode')",
                                  },
                                ],
                                staticClass: "danger",
                                on: {
                                  click: function ($event) {
                                    return _vm.deleteQrCode(i)
                                  },
                                },
                              },
                              [_c("w-fa", { attrs: { icon: "trash" } })],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    )
                  }),
                  _c(
                    "w-list-item",
                    {
                      on: {
                        click: function ($event) {
                          return _vm.addNewQrCode()
                        },
                      },
                    },
                    [
                      _c(
                        "w-list-item-icon",
                        [_c("w-fa", { attrs: { icon: "plus" } })],
                        1
                      ),
                      _c("w-list-item-text", [
                        _vm._v(
                          " " + _vm._s(_vm.$ct("create-new-qrcode")) + " "
                        ),
                      ]),
                    ],
                    1
                  ),
                ],
                2
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm.toEditQrCodeIndex != -1
        ? _c(
            "w-modal",
            { attrs: { value: "" } },
            [
              _c("app-qr-code-settings", {
                attrs: { model: _vm.model, layout: _vm.layout },
                on: {
                  close: function ($event) {
                    _vm.toEditQrCodeIndex = -1
                  },
                },
                model: {
                  value: _vm.layout.QrCodes[_vm.toEditQrCodeIndex],
                  callback: function ($$v) {
                    _vm.$set(_vm.layout.QrCodes, _vm.toEditQrCodeIndex, $$v)
                  },
                  expression: "layout.QrCodes[toEditQrCodeIndex]",
                },
              }),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }